const en = {
  common: {
    or: 'or',
    cancel: 'Cancel',
    reset: 'Reset',
    save: 'Save',
    saveReturn: 'Save and Return',
    search: 'Search',
    edit: 'Edit',
    new: 'New',
    export: 'Export to Excel',
    noDataToExport: 'No data to export',
    import: 'Import',
    discard: 'Discard',
    yes: 'Yes',
    no: 'No',
    pause: 'Pause',
    areYouSure: 'Are you sure?',
    view: 'View',
    destroy: 'Delete',
    mustSelectARow: 'Must select a row',
    start: 'Start',
    submit: 'Submit',
    end: 'End',
    select: 'Select',
    continue: 'Continue',
    filters: 'Filters',
    fullscreen: 'Full Screen',
    exitFullscreen: 'Exit full Screen',
    currencyIndicator: '$'
  },

  app: {
    title: 'ProductDeck.io',
  },

  api: {
    menu: 'API',
  },

  entities: {

    data: {
      menu: 'Data',
      title: 'Data',
    },

    admin: {
      menu: 'Admin',
      title: 'Admin',
    },
    
    reference: {
      menu:'Pages',
      home:'Home'
    },

    help: {
      menu:'Help',
      home:'Home'
    },

    research: {
        name: 'documents',
        label: 'Documents',
        menu: 'Documents',
        exporterFileName: 'research_export',
        list: {
          menu: 'Document',
          title: 'Document',
        },
        create: {
          success: 'Document successfully saved',
        },
        update: {
          success: 'Document successfully saved',
        },
        destroy: {
          success: 'Document successfully deleted',
        },
        destroyAll: {
          success: 'Document(s) successfully deleted',
        },
        edit: {
          title: 'Edit Document',
        },
        fields: {
          id: 'Id',
          'researchTitle': 'Title',
          'researchSummary': 'Summary',
          'researchDocument': 'PDF Document',
          'researchType': 'Type',
          'researchTags': 'Tags',
          'annotationURL': 'Annotation URL',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'researchType': {
            'Research_Document': 'Research Document',
            'Client_Interview': 'Client Interview', 
            'Industry_Report': 'Industry Report',
            'Market_Research': 'Market Research',
            'Meeting_Notes': 'Meeting Notes',
            'Competitor_Analysis': 'Competitor Analysis',
            'Product_Feedback': 'Product Feedback',
            'RFP': 'RFP',
            'RFI': 'RFI',
            'Other': 'Other',
            'Win/Loss_Analysis': 'Win/Loss Analysis',
            'Workshop_Session': 'Workshop Sessions'
          },
        },
        placeholders: {
          'researchTitle': 'Interesting research article',
          'researchSummary': 'Abstract of research document to help identify specific pieces of research',
          'researchType': 'Research Document',
          'researchTags': 'Idea'
        },
        hints: {
          'researchTitle': 'The name of the research item',
          'researchSummary': 'Enter a paragraph detailing the research',
          'researchType': 'The type of research item',
          'researchTags': 'Organize your research by associating one or more tags'
        },
        new: {
          title: 'New Document',
        },
        view: {
          title: 'View Document',
        },
        importer: {
          title: 'Import Document',
          fileName: 'research_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    slide: {
      name: 'slides',
      label: 'Slides',
      menu: 'Slide Templates',
      exporterFileName: 'slides_export',
      list: {
        menu: 'Slide',
        title: 'Slide',
      },
      create: {
        success: 'Slide successfully saved',
      },
      clone: {
        success: 'Slide has been cloned',
      },
      update: {
        success: 'Slide successfully saved',
      },
      destroy: {
        success: 'Slide successfully deleted',
      },
      destroyAll: {
        success: 'Slide(s) successfully deleted',
      },
      edit: {
        title: 'Edit Slide',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'slidetags': 'Tags',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
      },
      placeholders: {
        'name': 'Introduction',
        'slideTags': 'Idea'
      },
      hints: {
        'name': 'The name of the slide',
        'slideTags': 'Organize your slides by associating one or more tags'
      },
      new: {
        title: 'New Slide',
      },
      view: {
        title: 'View Slide',
      },
      importer: {
        title: 'Import Slide',
        fileName: 'slide_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    deck: {
      name: 'decks',
      label: 'Decks',
      menu: 'Decks',
      exporterFileName: 'decks_export',
      list: {
        menu: 'Deck',
        title: 'Deck',
      },
      create: {
        success: 'Deck successfully saved',
      },
      update: {
        success: 'Deck successfully saved',
      },
      destroy: {
        success: 'Deck successfully deleted',
      },
      destroyAll: {
        success: 'Deck(s) successfully deleted',
      },
      edit: {
        title: 'Edit Deck',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'deckTags': 'Tags',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
      },
      placeholders: {
        'name': 'Pitch Deck',
        'deckTags': 'Idea'
      },
      hints: {
        'name': 'The name of the deck',
        'slideTags': 'Organize your decks by associating one or more tags'
      },
      new: {
        title: 'New Deck',
      },
      view: {
        title: 'View Deck',
      },
      importer: {
        title: 'Import Deck',
        fileName: 'deck_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    contact: {
      name: 'contacts',
      label: 'Contacts',
      menu: 'Contacts',
      exporterFileName: 'contacts_export',
      list: {
        menu: 'Contact',
        title: 'Contact',
      },
      create: {
        success: 'Contact successfully saved',
      },
      update: {
        success: 'Contact successfully saved',
      },
      destroy: {
        success: 'Contact successfully deleted',
      },
      destroyAll: {
        success: 'Contact(s) successfully deleted',
      },
      edit: {
        title: 'Edit Contact',
      },
      fields: {
        id: 'Id',
        'firstName': 'First Name',
        'lastName': 'Last Name',
        'phone': 'Phone',
        'email': 'Email',
        'company': 'Company',
        'contactType': 'Contact Type',
        'website': 'Web Site',
        'linkedIn': 'LinkedIn',
        'notes': 'Notes',
        'fullName': 'Full Name',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'contactType': {
          'Advisor': 'Advisor',
          'Advocate': 'Advocate',
          'Competitor': 'Competitor',
          'Customer': 'Customer',
          'Expert': 'Expert',
          'Influencer': 'Influencer',
          'Internal Stakeholder': 'Internal Stakeholder',
          'Investor': 'Investor',
          'Partner': 'Partner',
          'Potential Investor': 'Potential Investor',
          'Prospect': 'Prospect',
          'Research Participant': 'Research Participant',
          'Vendor': 'Vendor',
          'Other': 'Other'
        },
      },
      placeholders: {
        'firstName': 'Joseph',
        'lastName': 'Jones',
        'phone': '+44 2343 2342',
        'email': 'joseph.jones@gmail.com',
        'company': 'ACME Corp',
        'contactType': 'Influencer',
        'website': 'www.acme.com',
        'linkedIn': 'https://linkedin.com/jjones',
        'notes': 'Met at recent industry conference. Follow up with a product demo.'
      },
      hints: {
        'firstName': 'The first name of the contact.',
        'lastName': 'The last name of the contact.',
        'phone': 'The phone number of the contact including dial code.',
        'email': 'The email address of the contact.',
        'company': 'The company associated with the contact.',
        'contactType': 'The category or type of contact.',
        'website': 'The website associated with the contact.',
        'linkedIn': 'The linkedin URL for the contact.',
        'notes': 'Any notes associated with this contact.'
      },
      new: {
        title: 'New Contact',
      },
      view: {
        title: 'View Contact',
      },
      importer: {
        title: 'Import Contact',
        fileName: 'contact_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    // Event
    event: {
      name: 'events',
      label: 'Events',
      menu: 'Events',
      exporterFileName: 'events_export',
      list: {
        menu: 'Event',
        title: 'Event',
      },
      create: {
        success: 'Event successfully saved',
      },
      update: {
        success: 'Event successfully saved',
      },
      destroy: {
        success: 'Event successfully deleted',
      },
      destroyAll: {
        success: 'Event(s) successfully deleted',
      },
      edit: {
        title: 'Edit Event',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'description': 'Description',
        'eventDate': 'Event Date',
        'eventType': 'Event Type',
        'location': 'Location',
        'notes': 'Notes',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'eventType': {
          'Release': 'Release',
          'Milestone': 'Milestone',
          'Conference': 'Conference',
          'Webinar': 'Webinar',
          'Launch': 'Launch',
          'Client Meeting': 'Client Meeting',
          'Win': 'Win',
          'Loss': 'Loss',
          'Pitch': 'Pitch',
          'Outage': 'Outage',
          'Other': 'Other'
        },
      },
      placeholders: {
        'name': 'Product Con',
        'description': 'Annual conference for product professionals.',
        'eventDate': '01/01/2023',
        'eventType': 'Conference',
        'location': 'London, UK',
        'notes': 'Useful event. Mainly B2B products.'
      },
      hints: {
        'name': 'The name of the event.',
        'description': 'A short description of the event.',
        'eventDate': 'The date or start date of an event.',
        'eventType': 'The type of event (e.g. conference or webinar).',
        'location': 'The event location if applicable,',
        'notes': 'Notes from this event.'
      },
      new: {
        title: 'New Event',
      },
      view: {
        title: 'View Event',
      },
      importer: {
        title: 'Import Event',
        fileName: 'event_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },


    feed: {
      name: 'feeds',
      label: 'Feeds',
      menu: 'Feeds',
      exporterFileName: 'feeds_export',
      list: {
        menu: 'Feed',
        title: 'Feed',
      },
      create: {
        success: 'Feed successfully saved',
      },
      update: {
        success: 'Feed successfully saved',
      },
      destroy: {
        success: 'Feed successfully deleted',
      },
      destroyAll: {
        success: 'Feed(s) successfully deleted',
      },
      edit: {
        title: 'Edit Feed',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'url': 'URL',
        'shortCode': 'Short Code',
        'feedCategory': 'Feed Category',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'feedCategory': {
          'Product': 'Product',
          'News': 'News',
          'Technology': 'Technology',
          'Finance': 'Finance',
          'Research': 'Research',
          'Healthcare': 'Healthcare',
          'Environment': 'Environment',
          'RegTech': 'RegTech'
        },
      },
      placeholders: {
        'name': 'Google News',
        'url': 'https://news.google.com/rss',
        'shortCode': 'Product',
        'feedCategory': 'News'
      },
      hints: {
        'name': 'The name of the feed.',
        'url': 'The RSS url of the feed.',
        'shortCode': 'A short code to identify this feed - used on quick selection buttons.',
        'feedCategory': 'The high level category for the feed.'
      },
      new: {
        title: 'New Feed',
      },
      view: {
        title: 'View Feed',
      },
      importer: {
        title: 'Import Feed',
        fileName: 'feed_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    insight: {
        name: 'insight',
        label: 'Insights',
        menu: 'Insights',
        exporterFileName: 'insight_export',
        list: {
          menu: 'Insights',
          title: 'Insights',
        },
        create: {
          success: 'Insight successfully saved',
        },
        update: {
          success: 'Insight successfully saved',
        },
        destroy: {
          success: 'Insight successfully deleted',
        },
        destroyAll: {
          success: 'Insight(s) successfully deleted',
        },
        edit: {
          title: 'Edit Insight',
        },
        fields: {
          id: 'Id',
          'insight': 'Insight',
          'source': 'Source',
          'collectedBy': 'Collected By',
          'pageRange': 'Page',
          'page': 'Page',
          'insightTags': 'Tags',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'insight': 'Interesting and significant insight',
          'page': '1',
          'insightTags': 'Product Management'
        },
        hints: {
          'insight': 'Enter the details of the insight',
          'source': 'The source that the insight was collected from',
          'collectedBy': 'The user who collected the insight',
          'page': 'The page of the document containing the insight',
          'insightTags': 'Tag insights to assist with organization and retrieval'
        },
        new: {
          title: 'New Insight',
        },
        view: {
          title: 'View Insight',
        },
        importer: {
          title: 'Import Insights',
          fileName: 'insight_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    product: {
        name: 'product',
        label: 'Products',
        menu: 'Products',
        exporterFileName: 'product_export',
        list: {
          menu: 'Products',
          title: 'Products',
        },
        create: {
          success: 'Product successfully saved',
        },
        update: {
          success: 'Product successfully saved',
        },
        destroy: {
          success: 'Product successfully deleted',
        },
        recalculate: {
          label: 'Recalculate',
          success: 'Product recalculation complete',
        },
        generateslides: {
          label: 'Generate Slides',
          success: 'Slide generation complete'
        },
        destroyAll: {
          success: 'Product(s) successfully deleted',
        },
        edit: {
          title: 'Edit Product',
        },
        fields: {
          id: 'Id',
          'productName': 'Name',
          'productDescription': 'Description',
          'productStatus': 'Status',
          'productTags': 'Tags',
          'productLaunchDateRange': 'Launch Date',
          'productLaunchDate': 'Launch Date',
          'growthRateRange': 'Growth Rate',
          'growthRate': 'Growth Rate',
          'currentRevenueRange': 'Current Revenue',
          'currentRevenue': 'Current Revenue',
          'firstYearRevenue': 'First Year Revenue',
          'firstYearRevenueRange': 'First Year Revenue Range',
          'marketSegments': 'Total Market Segments',
          'targetMarketSegments': 'Target Market Segments',
          'averageValue1to10': '$ for size (1-10)',
          'averageValue11to50': '$ for size (11-50)',
          'averageValue51to200': '$ for size (51-200)',
          'averageValue201to500': '$ for size (201-500)',
          'averageValue501to1000': '$ for size (501-1k)',
          'averageValue1001to5000': '$ for size (1001-5k)',
          'averageValue5001to10000': '$ for size (5001-10k)',
          'averageValue10001plus': '$ for (10001+)',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        analytics: {
          tam: 'Product TAM',
          sam: 'Product SAM',
          som: 'Product SOM'
        },
        enumerators: {
          'productStatus': {
            'Live': 'Live',
            'Idea': 'Idea',
            'Pre-Launch': 'Pre-Launch',
          },
        },
        placeholders: {
          'productName': 'Expense Manager',
          'productDescription': 'Product to help manage expenses',
          'productStatus': 'Live',
          'productTags': 'Product Management',
          'growthRate': '30',
          'currentRevenue': '1000',
          'firstYearRevenue': '1000',
          'averageValue1to10': '1000',
          'averageValue11to50': '1000',
          'averageValue51to200': '1000',
          'averageValue201to500': '1000',
          'averageValue501to1000': '1000',
          'averageValue1001to5000': '1000',
          'averageValue5001to10000': '1000',
          'averageValue10001plus': '1000'
        },
        hints: {
          'productName': 'The name of the product',
          'productDescription': 'Enter a description for the product',
          'productStatus': 'The current status of the product (e.g. Live, Idea, Pre-Launch)',
          'productTags': 'Add a tag tp help organize and retrieve different types of records',
          'productLaunchDate': 'The expected launch date of the product. Leave blank if already live.',
          'growthRate': 'The desired annual growth rate expressed as a percentage (e.g 30%)',
          'currentRevenue': 'The current annual revenue in dollars for this product. Use 0 if not yet launched.',
          'firstYearRevenue': 'The estimated revenue that this product will make in its first year.',
          'marketSegments': 'Select the total theoretical market segments for your product',
          'targetMarketSegments': 'Select the specific market segments you can service with your current business model',
          'averageValue1to10': 'The average value for a firm with between 1 and 10 employees',
          'averageValue11to50': 'The average value for a firm with between 11 and 50 employees',
          'averageValue51to200': 'The average value for a firm with between 51 and 200 employees',
          'averageValue201to500': 'The average value for a firm with between 201 and 500 employees',
          'averageValue501to1000': 'The average value for a firm with between 501 and 1000 employees',
          'averageValue1001to5000': 'The average value for a firm with between 1001 and 5000 employees',
          'averageValue5001to10000': 'The average value for a firm with between 5001 and 10000 employees',
          'averageValue10001plus': 'The average value for a firm with more than 10001 employees'
        },
        new: {
          title: 'New Product',
        },
        view: {
          title: 'View Product Details',
          productdetailsectiontitle: 'Product Details',
          productvaluesectiontitle: 'Product Value',
          productanalyticssectiontitle: 'Product Analytics',
          productforecastsectiontitle: 'Product Revenue Forecast',
          productforecastsummary: 'Based on the current revenue, growth rate and launch date, the chart below shows the annual revenue growth for this product.'
        },
        importer: {
          title: 'Import Products',
          fileName: 'product_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    company: {
        name: 'company',
        label: 'Companies',
        menu: 'Companies',
        exporterFileName: 'company_export',
        list: {
          menu: 'Companies',
          title: 'Companies',
        },
        create: {
          success: 'Company successfully saved',
        },
        update: {
          success: 'Company successfully saved',
        },
        destroy: {
          success: 'Company successfully deleted',
        },
        destroyAll: {
          success: 'Company(s) successfully deleted',
        },
        edit: {
          title: 'Edit Company',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'description': 'Description',
          'employeeCount': 'Employee Count',
          'industry': 'Primary Industry',
          'country': 'Country',
          'website': 'Website',
          'foundedRange': 'Founded',
          'founded': 'Founded',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'employeeCount': {
            '1-10': '1-10',
            '11-50': '11-50',
            '51-200': '51-200',
            '201-500': '201-500',
            '501-1000': '501-1000',
            '1001-5000': '1001-5000',
            '5001-10000': '5001-10000',
            '10001+': '10001+',
          },
        },
        placeholders: {
          'name': 'ACME Industries',
          'country': 'United States',
          'website': 'www.acme.com',
          'founded': '2000',
        },
        hints: {
          'name': 'The name of the Company',
          'description': 'Description of company activities',
          'employeeCount': 'The estimated number of employees at the company',
          'industry': 'The primary industry for the company',
          'country': 'The country where the primary headquarters of the company exists',
          'website': 'The name of the website (without the http:// or https://)',
          'founded': 'The year in which the company was founded (useful for identification of similar sounding companies)',
        },
        new: {
          title: 'New Company',
        },
        view: {
          title: 'View Company'
        },
        importer: {
          title: 'Import Companies',
          fileName: 'company_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      test: {
        name: 'test',
        label: 'Test',
        menu: 'Test',
        title: 'Test Page'
      },

    industry: {
        name: 'industry',
        label: 'Industries',
        menu: 'Industries',
        exporterFileName: 'industry_export',
        list: {
          menu: 'Industries',
          title: 'Industries',
        },
        create: {
          success: 'Industry successfully saved',
        },
        update: {
          success: 'Industry successfully saved',
        },
        destroy: {
          success: 'Industry successfully deleted',
        },
        destroyAll: {
          success: 'Industry(s) successfully deleted',
        },
        edit: {
          title: 'Edit Industry',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'name': 'Financial Services',
        },
        hints: {
          'name': 'The name of the industry sector',
        },
        new: {
          title: 'New Industry',
        },
        view: {
          title: 'View Industry',
          industryanalyticssectiontitle: 'Industry Analytics',
          industrycompaniessectiontitle: 'Companies within the Industry'
        },
        importer: {
          title: 'Import Industries',
          fileName: 'industry_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    country: {
        name: 'country',
        label: 'Countries',
        menu: 'Countries',
        exporterFileName: 'country_export',
        list: {
          menu: 'Countries',
          title: 'Countries',
        },
        create: {
          success: 'Country successfully saved',
        },
        update: {
          success: 'Country successfully saved',
        },
        destroy: {
          success: 'Country successfully deleted',
        },
        destroyAll: {
          success: 'Country(s) successfully deleted',
        },
        edit: {
          title: 'Edit Country',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'name': 'United Kingdom',
        },
        hints: {
          'name': 'The name of the country',
        },
        new: {
          title: 'New Country',
        },
        view: {
          title: 'View Country',
          countryanalyticssectiontitle: 'Country Analytics',
          countrycompaniessectiontitle: 'Companies within the Country'
        },
        importer: {
          title: 'Import Countries',
          fileName: 'country_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      jobTitle: {
        name: 'Job Title',
        label: 'Job Titles',
        menu: 'Job Titles',
        exporterFileName: 'jobTitle_export',
        list: {
          menu: 'Job Titles',
          title: 'Job Titles',
        },
        create: {
          success: 'Job Title successfully saved',
        },
        update: {
          success: 'Job Title successfully saved',
        },
        destroy: {
          success: 'Job Title successfully deleted',
        },
        destroyAll: {
          success: 'Job Title(s) successfully deleted',
        },
        edit: {
          title: 'Edit Job Title',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'name': 'Chief Executive Officer',
        },
        hints: {
          'name': 'The name of the job title',
        },
        new: {
          title: 'New Job Title',
        },
        view: {
          title: 'View Job Title',
        },
        importer: {
          title: 'Import Job Titles',
          fileName: 'jobTitle_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      board: {
        name: 'board',
        label: 'Boards',
        menu: 'Boards',
        exporterFileName: 'board_export',
        list: {
          menu: 'Boards',
          title: 'Boards',
        },
        create: {
          success: 'Board successfully saved',
        },
        update: {
          success: 'Board successfully saved',
        },
        destroy: {
          success: 'Board successfully deleted',
        },
        destroyAll: {
          success: 'Board(s) successfully deleted',
        },
        edit: {
          title: 'Edit Board',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'data': 'Data',
          'options': 'Options',
          'boardType': 'Board Type',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'boardType': {
            'Todo': 'To Do list (To Do, In Progress, Done)',
            'SWOT': 'SWOT (Strengths, Weaknesses, Oppportunities, Threats)',
            'NowNextLater': 'Agile Plan (Now, Next, Later)',
            'DECK': 'DECK (Delighters, Enablers, Customer Requests, Keeping the Lights On)',
          },
        },
        placeholders: {
          'name': 'To Do',
          'data': '{}',
          'boardType': 'To Do',
          'options': '{}'
        },
        hints: {
          'name': 'The name of the board',
          'boardType': 'Select the type of board to pre-configure lanes and behaviours.'
        },
        new: {
          title: 'New Board',
        },
        view: {
          title: 'View Board',
        },
        importer: {
          title: 'Import Boards',
          fileName: 'board_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    model: {
        name: 'model',
        label: 'Models',
        menu: 'Models',
        exporterFileName: 'model_export',
        list: {
          menu: 'Models',
          title: 'Models',
        },
        create: {
          success: 'Model successfully saved',
        },
        update: {
          success: 'Model successfully saved',
        },
        destroy: {
          success: 'Model successfully deleted',
        },
        recalculate: {
          label: 'Recalculate',
          success: 'Model recalculation complete',
        },
        destroyAll: {
          success: 'Model(s) successfully deleted',
        },
        edit: {
          title: 'Edit Model',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'description': 'Description',
          'products': 'Products',
          'marketSegments': 'Market Segments',
          'modelTags': 'Tags',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        analytics: {
          tam: 'Model TAM',
          sam: 'Model SAM',
          som: 'Model SOM'
        },
        enumerators: {

        },
        placeholders: {
          'name': 'Current Market Model',
          'description': 'A model that includes all current products and markets',
          'products': 'Expense Manager',
          'modelTags': 'Product Management'
        },
        hints: {
          'name': 'A short name to identify this model',
          'description': 'A longer description of the objective or purpose of the model',
          'products': 'The products to include in the model',
          'marketSegments': 'Specify the market segments to include in this model',
          'modelTags': 'Add a tag to help organize and retrieve records of different types'
        },
        new: {
          title: 'New Model',
        },
        view: {
          title: 'View Model',
          modelanalyticssectiontitle: 'Model Analytics',
          modelforecastsectiontitle: 'Model Revenue Forecast',
          modelforecastsummary: 'Based on the current revenue, growth rate and launch date, the chart below shows the annual revenue growth for all products within this model.',
          modelnoanalyticsmessage: 'There are no analytics available for this model. Try clicking on Recalculate.',
          modelnoforecastmessage: 'There is no forecast yet for this model. Try clicking on Recalculate.'
        },
        importer: {
          title: 'Import Models',
          fileName: 'model_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    marketSegment: {
        name: 'marketSegment',
        label: 'Market Segments',
        menu: 'Market Segments',
        exporterFileName: 'marketSegment_export',
        list: {
          menu: 'Market Segments',
          title: 'Market Segments',
        },
        create: {
          success: 'Market Segment successfully saved',
        },
        update: {
          success: 'Market Segment successfully saved',
        },
        destroy: {
          success: 'Market Segment successfully deleted',
        },
        destroyAll: {
          success: 'Market Segment(s) successfully deleted',
        },
        edit: {
          title: 'Edit Market Segment',
        },
        recalculate: {
          label: 'Recalculate',
          success: 'Model recalculation complete',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'industries': 'Industries',
          'countries': 'Countries',
          'employeeCount': 'Employee Count',
          'valueModifierRange': 'Value Modifier',
          'valueModifier': 'Value Modifier',
          'somPC': "Share of the Market (%)",
          'sOMModifier': 'Ability to obtain',
          'sAMModifier': 'Ability to service',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'employeeCount': {
            '1-10': '1-10',
            '11-50': '11-50',
            '51-200': '51-200',
            '201-500': '201-500',
            '501-1000': '501-1000',
            '1001-5000': '1001-5000',
            '5001-10000': '5001-10000',
            '10001+': '10001+',
          },
          'sOMModifier': {
            'Very_Easy': 'Very Easy (90%)',
            'Easy': 'Easy (75%)',
            'Medium': 'Medium (50%)' ,
            'Difficult': 'Difficult (25%)',
            'Very_Difficult': 'Very Difficult (10%)',
          },
          'sAMModifier': {
            'Very_Easy': 'Very Easy (90%)',
            'Easy': 'Easy (75%)',
            'Medium': 'Medium (50%)',
            'Difficult': 'Difficult (25%)',
            'Very_Difficult': 'Very Difficult (10%)',
          },
        },
        placeholders: {
          'name': 'Core Markets',
          'industries': 'Financial Services',
          'countries': 'United States',
          'employeeCount': '1-10',
          'valueModifier': '20',
          'somPC': '1.00',
          'sOMModifier': 'Medium',
          'sAMModifier': 'Medium',
        },
        hints: {
          'name': 'The name for this market segment',
          'industries': 'One or more industries related to this market segment',
          'countries': 'One or more countries that relate to this market segment',
          'employeeCount': 'One or more company sizes (by employee count) related to this market segment',
          'valueModifier': 'Percentage increase or decrease on standard pricing achievable within this market segment',
          'somPC': 'The estimated achievable share of the market expressed as a percentage',
          'sOMModifier': 'Specify the ability to obtain a new customer within this market segment',
          'sAMModifier': 'Specify the ability to service this market',
        },
        new: {
          title: 'New Market Segment',
        },
        view: {
          title: 'View Market Segment',
          companyInMarketSegments: ' is in the following Market Segments'
        },
        importer: {
          title: 'Import MarketSegments',
          fileName: 'marketSegment_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      marketSegmentData: {
        name: 'marketSegmentData',
        label: 'Market Segment Data',
        menu: 'Segment Data',
        exporterFileName: 'marketSegmentData_export',
        list: {
          menu: 'Market Segment Data',
          title: 'Market Segment Data',
        },
        create: {
          success: 'Market Segment Data successfully saved',
        },
        update: {
          success: 'Market Segment Data successfully saved',
        },
        destroy: {
          success: 'Market Segment Data successfully deleted',
        },
        destroyAll: {
          success: 'Market Segment Data successfully deleted',
        },
        edit: {
          title: 'Edit Market Segment Data',
        },
        fields: {
          id: 'Id',
          'industry': 'Industry',
          'country': 'Country',
          'employeeCount': 'Employee Count',
          'count': 'Count',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'employeeCount': {
            '1-10': '1-10',
            '11-50': '11-50',
            '51-200': '51-200',
            '201-500': '201-500',
            '501-1000': '501-1000',
            '1001-5000': '1001-5000',
            '5001-10000': '5001-10000',
            '10001+': '10001+',
          }
        },
        placeholders: {
          'industry': 'Financial Services',
          'country': 'United States',
          'employeeCount': '1-10',
          'count': '10'
        },
        hints: {
          'industry': 'The industry sector for this market segment data',
          'country': 'The country for this market segment data',
          'employeeCount': 'The company sizes (by employee count) related to this market segment',
          'count': 'The total number of firms for this market segment'
        },
        new: {
          title: 'New Market Segment Data',
        },
        view: {
          title: 'View Market Segment Data',
        },
        importer: {
          title: 'Import Market Segment Data',
          fileName: 'marketSegmentData_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    tag: {
        name: 'tag',
        label: 'Tags',
        menu: 'Tags',
        exporterFileName: 'tag_export',
        list: {
          menu: 'Tags',
          title: 'Tags',
        },
        create: {
          success: 'Tag successfully saved',
        },
        update: {
          success: 'Tag successfully saved',
        },
        destroy: {
          success: 'Tag successfully deleted',
        },
        destroyAll: {
          success: 'Tag(s) successfully deleted',
        },
        edit: {
          title: 'Edit Tag',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'name': 'idea',
        },
        hints: {
          'name': 'The name of the tag',
        },
        new: {
          title: 'New Tag',
        },
        view: {
          title: 'View Tag',
          researchsectiontitle: 'Related Documents',
          insightsectiontitle: 'Related Insights',
          productsectiontitle: 'Related Products'
        },
        importer: {
          title: 'Import Tags',
          fileName: 'tag_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      bookmark: {
        name: 'bookmark',
        label: 'Bookmarks',
        menu: 'Bookmarks',
        exporterFileName: 'bookmark_export',
        list: {
          menu: 'Bookmarks',
          title: 'Bookmarks',
        },
        create: {
          success: 'Bookmark successfully saved',
        },
        update: {
          success: 'Bookmark successfully saved',
        },
        destroy: {
          success: 'Bookmark successfully deleted',
        },
        snapshot: {
          label: 'Take Snapshot',
          success: 'Bookmark successfully captured',
          snapshotSectionTitle: 'Latest Snapshot',
          snapshotTaken: 'Latest snapshot taken'
        },
        createResearch: {
          label: 'Create Document Item',
          success: 'Document Item has been created'
        },
        destroyAll: {
          success: 'Bookmark(s) successfully deleted',
        },
        edit: {
          title: 'Edit Bookmark',
        },
        fields: {
          id: 'Id',
          'label': 'Label',
          'url': 'Url',
          'bookmarkTags': 'Tags',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'label': 'Competitor Blog Post',
          'url': 'https://acme.com/blog',
          'bookmarkTags': 'Product Management'
        },
        hints: {
          'label': 'A short summary for the link or web page',
          'url': 'The full address of the web page or web site including the http:// or https://',
          'bookmarkTags': 'Use tags to organize and group your bookmarks'
        },
        new: {
          title: 'New Bookmark',
        },
        view: {
          title: 'View Bookmark',
        },
        importer: {
          title: 'Import Bookmarks',
          fileName: 'bookmark_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

      // topics
      topic: {
        name: 'topic',
        label: 'Topics',
        menu: 'Topics',
        exporterFileName: 'topic_export',
        list: {
          menu: 'Topics',
          title: 'Topics',
        },
        create: {
          success: 'Topic successfully saved',
        },
        update: {
          success: 'Topic successfully saved',
        },
        destroy: {
          success: 'Topic successfully deleted',
        },
        destroyAll: {
          success: 'Topic(s) successfully deleted',
        },
        edit: {
          title: 'Edit Topic',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'markdown': 'Markdown',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'name': 'Market Study',
          'markdown': 'Sample content for market study'
        },
        hints: {
          'name': 'The name of the topic',
          'markdown': 'The content of the topic in markdown format'
        },
        new: {
          title: 'New Topic',
        },
        view: {
          title: 'View Topic',
        },
        importer: {
          title: 'Import Topic',
          fileName: 'topic_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },


      definition: {
        name: 'definition',
        label: 'Definitions',
        menu: 'Definitions',
        exporterFileName: 'definition_export',
        list: {
          menu: 'Definitions',
          title: 'Definitions',
        },
        create: {
          success: 'Definition successfully saved',
        },
        update: {
          success: 'Definition successfully saved',
        },
        destroy: {
          success: 'Definition successfully deleted',
        },
        destroyAll: {
          success: 'Definition(s) successfully deleted',
        },
        edit: {
          title: 'Edit Definition',
        },
        fields: {
          id: 'Id',
          'term': 'Term',
          'description': 'Description',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {

        },
        placeholders: {
          'term': 'Backlog',
          'description': 'An ordered list of prioritized items for development.'
        },
        hints: {
          'term': 'An acronymn, word or short phrase.',
          'description': 'A brief description of the term'
        },
        new: {
          title: 'New Definition',
        },
        view: {
          title: 'View Definition',
        },
        importer: {
          title: 'Import Definitions',
          fileName: 'definition_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },


      cohort: {
        name: 'cohort',
        label: 'Cohorts',
        menu: 'Cohorts',
        exporterFileName: 'cohort_export',
        list: {
          menu: 'Cohorts',
          title: 'Cohorts',
        },
        create: {
          success: 'Cohort successfully saved',
        },
        update: {
          success: 'Cohort successfully saved',
        },
        destroy: {
          success: 'Cohort successfully deleted',
        },
        destroyAll: {
          success: 'Cohort(s) successfully deleted',
        },
        edit: {
          title: 'Edit Cohort',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'jobTitles': 'Job Titles',
          'countries': 'Countries',
          'industries': 'Industries',
          'employeeCount': 'Employee Count',
          'count' : 'Count',
          'weightedValue' : 'Weighted Value',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'employeeCount': {
            '1-10': '1-10',
            '11-50': '11-50',
            '51-200': '51-200',
            '201-500': '201-500',
            '501-1000': '501-1000',
            '1001-5000': '1001-5000',
            '5001-10000': '5001-10000',
            '10001+': '10001+',
          },
        },
        placeholders: {
          'name': 'Sales Executives in the United States',
          'jobTitles': 'Sales Executives',
          'countries': 'United States',
          'industries': 'Accounting',
          'employeeCount': '51-200',
          'count': '1200'
        },
        hints: {
          'name': 'A unique name for your cohort',
          'jobTitles': 'Select zero or more job titles form the predefined list',
          'countries': 'Select zero or more countries to filter',
          'industries': 'Select zero or more industries to filter',
          'employeeCount': 'Select zero or more firm sizes by employee count',
          'count': 'The number of people within this cohort'
        },
        new: {
          title: 'New Cohort',
        },
        view: {
          title: 'View Cohort',
        },
        importer: {
          title: 'Import Cohort',
          fileName: 'cohort_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },

    customer: {
        name: 'customer',
        label: 'Customers',
        menu: 'Customers',
        exporterFileName: 'customer_export',
        list: {
          menu: 'Customers',
          title: 'Customers',
        },
        create: {
          success: 'Customer successfully saved',
        },
        update: {
          success: 'Customer successfully saved',
        },
        destroy: {
          success: 'Customer successfully deleted',
        },
        destroyAll: {
          success: 'Customer(s) successfully deleted',
        },
        edit: {
          title: 'Edit Customer',
        },
        fields: {
          id: 'Id',
          'name': 'Name',
          'website': 'Website',
          'employeeCount': 'Employee Count',
          'industry': 'Industry',
          'country': 'Country',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          createdAtRange: 'Created at',
        },
        enumerators: {
          'employeeCount': {
            'Unknown': 'Unknown',
            '1-10': '1-10',
            '11-50': '11-50',
            '51-200': '51-200',
            '201-500': '201-500',
            '501-1000': '501-1000',
            '1001-5000': '1001-5000',
            '5001-10000': '5001-10000',
            '10001+': '10001+',
          },
        },
        placeholders: {
          'name': 'ACME Industries',
          'website': 'www.acme.com',
          'employeeCount': '11-50',
          'industry': 'Financial Services',
          'country': 'United States',
        },
        hints: {
          'name': 'The name of the customer',
          'website': 'The website without the https:// or http://',
          'employeeCount': 'The estimated number of employees at the customer',
          'industry': 'The primary industry of the customer',
          'country': 'Select the country of the company headquarters',
        },
        new: {
          title: 'New Customer',
        },
        view: {
          title: 'View Customer',
        },
        importer: {
          title: 'Import Customers',
          fileName: 'customer_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },
  },

  auth: {
    tenants: 'Workspaces',
    profile: {
      title: 'Profile',
      success: 'Profile successfully updated',
    },
    createAnAccount: 'Create an account',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    signin: 'Sign in',
    signup: 'Sign up',
    signout: 'Sign out',
    alreadyHaveAnAccount:
      'Already have an account? Sign in.',
    social: {
      errors: {
        'auth-invalid-provider':
          'This email is already registered to another provider.',
        'auth-no-email': `The email associated with this account is private or inexistent.`,
      },
    },
    signinWithAnotherAccount:
      'Sign in with another account',
    emailUnverified: {
      message: `Please confirm your email at <strong>{0}</strong> to continue.`,
      submit: `Resend email verification`,
    },
    emptyPermissions: {
      message: `You have no permissions yet. Wait for the admin to grant you privileges.`,
    },
    passwordResetEmail: {
      message: 'Send password reset email',
      error: `Email not recognized`,
    },
    passwordReset: {
      message: 'Reset password',
    },
    passwordChange: {
      title: 'Change Password',
      success: 'Password successfully changed',
      mustMatch: 'Passwords must match',
    },
    emailAddressVerificationEmail: {
      error: `Email not recognized`,
    },
    verificationEmailSuccess: `Verification email successfully sent`,
    passwordResetEmailSuccess: `Password reset email successfully sent`,
    passwordResetSuccess: `Password successfully changed`,
    verifyEmail: {
      success: 'Email successfully verified.',
      message:
        'Just a moment, your email is being verified...',
    },
  },

  roles: {
    admin: {
      label: 'Admin',
      description: 'Full access to all resources',
    },
    custom: {
      label: 'Custom Role',
      description: 'Custom role access',
    },
  },

  user: {
    fields: {
      id: 'Id',
      avatars: 'Avatar',
      email: 'Email',
      emails: 'Email(s)',
      fullName: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      status: 'Status',
      phoneNumber: 'Phone Number',
      role: 'Role',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      roleUser: 'Role/User',
      roles: 'Roles',
      createdAtRange: 'Created at',
      password: 'Password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      newPasswordConfirmation: 'New Password Confirmation',
      rememberMe: 'Remember me',
    },
    status: {
      active: 'Active',
      invited: 'Invited',
      'empty-permissions': 'Waiting for Permissions',
    },
    invite: 'Invite',
    validations: {
      // eslint-disable-next-line
      email: 'Email ${value} is invalid',
    },
    title: 'Users',
    menu: 'Users',
    doAddSuccess: 'User(s) successfully saved',
    doUpdateSuccess: 'User successfully saved',
    exporterFileName: 'users_export',
    doDestroySuccess: 'User successfully deleted',
    doDestroyAllSelectedSuccess:
      'Users successfully deleted',
    edit: {
      title: 'Edit User',
    },
    new: {
      title: 'Invite User(s)',
      titleModal: 'Invite User',
      emailsHint:
        'Separate multiple email addresses using the comma character.',
    },
    view: {
      title: 'View User',
      activity: 'Activity',
    },
    importer: {
      title: 'Import Users',
      fileName: 'users_import_template',
      hint:
        'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
    },
    errors: {
      userAlreadyExists:
        'User with this email already exists',
      userNotFound: 'User not found',
      revokingOwnPermission: `You can't revoke your own admin permission`,
    },
  },

  tenant: {
    name: 'tenant',
    label: 'Workspaces',
    menu: 'Workspaces',
    list: {
      menu: 'Workspaces',
      title: 'Workspaces',
    },
    create: {
      button: 'Create Workspace',
      success: 'Workspace successfully saved',
    },
    update: {
      success: 'Workspace successfully saved',
    },
    destroy: {
      success: 'Workspace successfully deleted',
    },
    destroyAll: {
      success: 'Workspace(s) successfully deleted',
    },
    edit: {
      title: 'Edit Workspace',
    },
    fields: {
      id: 'Id',
      name: 'Name',
      url: 'URL',
      tenantName: 'Workspace Name',
      currency: 'Currency',
      peopleDataLabsAPIKey:'People Data Labs API Key',
      tenantId: 'Workspace',
      tenantUrl: 'Workspace URL',
      plan: 'Plan',
    },
    hints: {
      currency: 'Primary currency to be used for this workspace',
      tenantName: 'Enter a unique name to identify your first workspace',
      peopleDataLabsAPIKey: 'Enter your People Data Labs API Key (if registered)'
    },
    placeholders: {
      currency: 'US Dollars',
      tenantName: 'Product Space',
      peopleDataLabsAPIKey: 'f59ebb5eb8c73369c20c1ff2d7faf773778fc1539e300e693ceb3192885b3b0d'
    },
    enumerators: {
      tenantCurrency: {
        usDollars: 'US Dollars',
        gbp: 'Great British Pounds'
      }
    },
    new: {
      title: 'New Workspace',
    },
    invitation: {
      view: 'View Invitations',
      invited: 'Invited',
      accept: 'Accept Invitation',
      decline: 'Decline Invitation',
      declined: 'Invitation successfully declined',
      acceptWrongEmail: 'Accept Invitation With This Email',
    },
    select: 'Select Workspace',
    validation: {
      url:
        'Your workspace URL can only contain lowercase letters, numbers and dashes (and must start with a letter or number).',
    },
  },



  plan: {
    menu: 'Plans',
    title: 'Plans',

    free: {
      label: 'Free',
      price: '$0',
    },
    essentials: {
      label: 'Essentials',
      price: '$1',
    },
    pro: {
      label: 'Pro',
      price: '$2',
    },

    pricingPeriod: '/month',
    current: 'Current Plan',
    subscribe: 'Subscribe',
    manage: 'Manage Subscription',
    cancelAtPeriodEnd:
      'This plan will be canceled at the end of the period.',
    somethingWrong:
      'There is something wrong with your subscription. Please go to manage subscription for more details.',
    notPlanUser: `You are not the manager of this subscription.`,
  },

  auditLog: {
    menu: 'Audit Logs',
    title: 'Audit Logs',
    exporterFileName: 'audit_log_export',
    entityNamesHint:
      'Separate multiple entities using the comma character.',
    fields: {
      id: 'Id',
      timestampRange: 'Period',
      entityName: 'Entity',
      entityNames: 'Entities',
      entityId: 'Entity ID',
      action: 'Action',
      values: 'Values',
      timestamp: 'Date',
      createdByEmail: 'User Email',
    },
  },
  test: {
    menu: 'Test Page'
  },
  settings: {
    title: 'Settings',
    menu: 'Settings',
    save: {
      success:
        'Settings successfully saved. The page will reload in {0} seconds for changes to take effect.',
    },
    fields: {
      primary: 'Primary Color',
      secondary: 'Secondary Color',
      logos: 'Logo',
      backgroundImages: 'Background Images',
      shade: 'Shade',
    },
  },
  dashboard: {
    menu: 'Home page',
    message: `Strat.Plan (2021 v1.0)`,
    recentinsights: 'Recent Insights'
  },
  errors: {
    backToHome: 'Back to home',
    403: `Sorry, you don't have access to this page`,
    404: 'Sorry, the page you visited does not exist',
    500: 'Sorry, the server is reporting an error',
    429: 'Too many requests. Please try again later.',
    forbidden: {
      message: 'Forbidden',
    },
    validation: {
      message: 'An error occurred',
    },
    defaultErrorMessage: 'Ops, an error occurred',
  },

  preview: {
    error:
      'Sorry, this operation is not allowed in preview mode.',
  },
  
  // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
  /* eslint-disable */
  validation: {
    mixed: {
      default: '${path} is invalid',
      required: '${path} is required',
      oneOf:
        '${path} must be one of the following values: ${values}',
      notOneOf:
        '${path} must not be one of the following values: ${values}',
      notType: ({ path, type, value, originalValue }) => {
        return `${path} must be a ${type}`;
      },
    },
    string: {
      length:
        '${path} must be exactly ${length} characters',
      min: '${path} must be at least ${min} characters',
      max: '${path} must be at most ${max} characters',
      matches:
        '${path} must match the following: "${regex}"',
      email: '${path} must be a valid email',
      url: '${path} must be a valid URL',
      trim: '${path} must be a trimmed string',
      lowercase: '${path} must be a lowercase string',
      uppercase: '${path} must be a upper case string',
      selected: '${path} must be selected',
    },
    number: {
      min:
        '${path} must be greater than or equal to ${min}',
      max: '${path} must be less than or equal to ${max}',
      lessThan: '${path} must be less than ${less}',
      moreThan: '${path} must be greater than ${more}',
      notEqual: '${path} must be not equal to ${notEqual}',
      positive: '${path} must be a positive number',
      negative: '${path} must be a negative number',
      integer: '${path} must be an integer',
    },
    date: {
      min: '${path} field must be later than ${min}',
      max: '${path} field must be at earlier than ${max}',
    },
    boolean: {},
    object: {
      noUnknown:
        '${path} field cannot have keys not specified in the object shape',
    },
    array: {
      min: ({ min, path }) =>
        min === 1
          ? `${path} is required`
          : `${path} field must have at least ${min} items`,
      max:
        '${path} field must have less than or equal to ${max} items',
    },
  },
  /* eslint-disable */
  fileUploader: {
    upload: 'Upload',
    image: 'You must upload an image',
    size: 'File is too big. Max allowed size is {0}',
    formats: `Invalid format. Must be one of: {0}.`,
  },
  importer: {
    line: 'Line',
    status: 'Status',
    pending: 'Pending',
    imported: 'Imported',
    error: 'Error',
    total: `{0} imported, {1} pending and {2} with error`,
    importedMessage: `Processed {0} of {1}.`,
    noNavigateAwayMessage:
      'Do not navigate away from this page or import will be stopped.',
    completed: {
      success:
        'Import completed. All rows were successfully imported.',
      someErrors:
        'Processing completed, but some rows were unable to be imported.',
      allErrors: 'Import failed. There are no valid rows.',
    },
    form: {
      downloadTemplate: 'Download the template',
      hint:
        'Click or drag the file to this area to continue',
    },
    list: {
      discardConfirm:
        'Are you sure? Non-imported data will be lost.',
    },
    errors: {
      invalidFileEmpty: 'The file is empty',
      invalidFileExcel:
        'Only excel (.xlsx) files are allowed',
      invalidFileUpload:
        'Invalid file. Make sure you are using the last version of the template.',
      importHashRequired: 'Import hash is required',
      importHashExistent: 'Data has already been imported',
    },
  },

  autocomplete: {
    loading: 'Loading...',
    noOptions: 'No data found',
  },

  imagesViewer: {
    noImage: 'No image',
  },

  table: {
    noData: 'No records found',
    loading: 'Loading...',
  },

  pagination: {
    labelDisplayedRows: '{0}-{1} of {2}',
    labelRowsPerPage: 'Per page:',
  },
};

export default en;
